
export const FILTER = {
    "filter_id": "",
    "comparison": "",
    "order_id": "",
    "ordering": 0,
    "type": 0,
    // "scope_type" : 0,
    "value_1": "",
    "value_2": "",
    "where_type": ""
}


export const REPORT = {
    name: "",
    type: 1,
    scope_type: 0,
    group: "Default",
    order_1: 0,
    order_2: 0,
    order_3: 0,
    columns: [],
    cached_row_total: null,
    date_changed: 0,
    filters: [],
    clerk: "",
    report_id: null,
}

export const ORDER = {
    "cancel_date": null,
    "clerk_code": "",
    "condition_code": " ",
    "customer": null,
    "customer_po": "",
    "invoice": "",
    "invoice_date": null,
    "invoice_price": null,
    "is_single_title_order": false,
    "ms_split": [],
    "note": [],
    "order_id": "",
    "order_number": "",
    "order_separator": "",
    "po_number": "",
    "primary_code": "",
    "quantity": 0,
    "review_days": 0,
    "status": "Pend",
    "status_date": 0,
    "supplier": "HCP",
    "supplier_discount": 45,
    "supplier_name" : "",
    "supplier_currency" : "",
    "supplier_country": "",
    "prepay_issue_id" : null,
    "req_date" : null,
}


export const TRANSACTION = {
    "acr_id": "",
    "header": {
        "amount": 0,
        "calculated_totals": null,
        "can_change": 0,
        "cancel_date": 0,
        "clerk_code": "",
        "combine": 0,
        "customer_bill_to": null,
        "customer_ship_to": null,
        "date": 0,
        "group": "",
        "hold_till": 0,
        "invoice": "",
        "locked": "",
        "log_code": "",
        "log_date": 0,
        "marked": 0,
        "notes": "",
        "partial": 0,
        "per": "",
        "points_earned": 0,
        "points_total": 0,
        "frequent_buyer_redeem": 0,
        "purchase_order": "",
        "reconcile": "",
        "sale_net": 0,
        "sent_via_eps": 0,
        "ship_via": "",
        "tax_id": "",
        "terms": "",
        "type": ""
    },
    "items" : []
}

export const TRANSACTION_ITEM = {
    "available_onhand": null,
    "class_": "",
    "condition_code": "",
    "cost": null,
    "customer_ship_to": "",
    "cust_po": "",
    "date": 0,
    "discount": null,
    "discount_expected": null,
    "item_price": null,
    "points": "",
    "point_of_sale_id": "",
    "prepay_status": "",
    "price": null,
    "primary_code": "",
    "profit_margin": null,
    "quantity": 0,
    "status": "",
    "tax_code": "",
    "title": "",
    "total_price": 0,
    "type": "",
    "type_2": "",
    "type_2_status": "",
    "void_": ""
}